const reasons = [
  { icon: 'ri-eye-off-line', text: 'Нет диагностики — обучение не связано с реальным уровнем сотрудников' },
  { icon: 'ri-link-unlink', text: 'Обучение не связано с задачами бизнеса' },
  { icon: 'ri-tools-line', text: 'Мало практики — новые знания не отработаны на реальных ситуациях' },
  { icon: 'ri-lock-line', text: 'Нет возможности применять навыки в работе' },
  { icon: 'ri-user-unfollow-line', text: 'Руководитель не поддерживает изменения' },
  { icon: 'ri-chat-off-line', text: 'Нет обратной связи после обучения' },
  { icon: 'ri-user-heart-line', text: 'Нет наставничества, которое помогает закрепить навык' },
  { icon: 'ri-radar-line', text: 'Отсутствует повторная оценка изменений' },
  { icon: 'ri-calendar-line', text: 'Обучение проводится как разовое мероприятие' },
];

export default function WhyTrainingFails() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему обучение не всегда приводит к развитию
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Можно провести хороший тренинг и не получить изменений. Дело не в качестве тренинга, а в отсутствии системы вокруг него.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {reasons.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>

        <div className="border-l-4 border-teal-600 bg-white rounded-r-xl p-6 md:p-8 max-w-3xl mx-auto">
          <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
            Развитие начинается тогда, когда новые знания превращаются в рабочее поведение.
          </p>
        </div>
      </div>
    </section>
  );
}